import React, { Component } from 'react';
import PropTypes from 'react-proptypes';
import anime from 'animejs';

export default class MonestLoader extends Component {

    componentDidMount() {
        anime({
            targets: '#lineDrawing .lines path',
            strokeDashoffset: [anime.setDashoffset, 0],
            easing: 'easeInOutSine',
            duration: 1000,
            delay: 0,
            direction: 'alternate',
            loop: true,
            update: (anim) => {

                if (!this.svg) {
                    return;
                }

                if (anim.progress === 0) {
                    this.svg.style.transform = 'rotateY(0)';
                } else if (anim.progress === 100) {
                    this.svg.style.transform = 'rotateY(180deg)';
                }
            },
        });
    }

    render() {
        const { size, subtitle } = this.props;

        const width = `${size * 40}px`;
        const height = `${size * 18}px`;

        return (
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '1em',
                }}
            >
                <div id="lineDrawing">
                    <svg ref={(obj) => { this.svg = obj; }} width={width} height={height} viewBox="0 0 65.1 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="svg-1">
                        <g id="fluxo" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" className="lines">
                            <g id="Dashboard-devedores" transform="translate(-28.000000, -31.000000)">
                                <g id="Group-10" transform="translate(28.000000, 26.000000)">
                                    <g id="Group-2" transform="translate(0.000000, 5.000000)">
                                        <path d="M2.48291016,9.22900391 C3.30680339,14.7436523 5.37801107,17.5009766 8.6965332,17.5009766 C12.0150553,17.5009766 14.3864746,14.6673177 15.810791,9 C17.2381999,3.54752604 18.9679362,0.821289062 21,0.821289062 C23.0320638,0.821289062 24.746582,3.54752604 26.1435547,9 C27.1704102,14.6673177 29.3054606,17.5009766 32.5487061,17.5009766 C35.7919515,17.5009766 37.9318848,14.6673177 38.9685059,9 C40.3247477,3.54752604 42.0219116,0.821289063 44.0599976,0.821289062 C46.0980835,0.821289062 47.8598226,3.60123698 49.3452148,9.16113281 C50.7239583,14.7210286 53.0681152,17.5009766 56.3776855,17.5009766 C59.6872559,17.5009766 61.7609049,14.7436523 62.5986328,9.22900391" stroke="#7740F9" strokeWidth="2" />
                                        <path d="M60.332205,11.2677675 C61.3084969,12.2440775 62.8915,12.2440775 63.8677919,11.2677675 C64.8440673,10.2913065 64.8440673,8.70853004 63.8677919,7.73221998 C62.8915,6.75592667 61.3084969,6.75592667 60.332205,7.73221998 C59.3559296,8.70853004 59.3559296,10.2913065 60.332205,11.2677675" fill="#00C1ED" />
                                        <path d="M1.23224473,11.2677675 C2.20855289,12.2440775 3.79144422,12.2440775 4.76776888,11.2677675 C5.74407704,10.2913065 5.74407704,8.70853004 4.76776888,7.73221998 C3.79144422,6.75592667 2.20855289,6.75592667 1.23224473,7.73221998 C0.255918424,8.70853004 0.255918424,10.2913065 1.23224473,11.2677675" fill="#00C1ED" />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>
                { subtitle && (
                    <div className="text-center" style={{ margin: '32px 0' }}>
                        <span className="font-24 font-purple semi-bold">{ subtitle }</span>
                    </div>
                )}
            </div>
        );
    }

}

MonestLoader.propTypes = {
    size: PropTypes.number,
};

MonestLoader.defaultProps = {
    size: 1,
};
